import { useWorkingPlatform } from '@repo/platform';
import { useDialog } from '@repo/ui';
import { AuthGuard } from '@repo/user-session';
import { CICollectionRequest, SignBackButtonLayout, SignCloseButtonLayout } from '@repo/user-sign';
import { ReactElement } from 'react';

import { useExitService } from '@/lib/hooks/use-exit-service';

const CiPreparePage = () => {
  const { workingPlatform } = useWorkingPlatform();
  const { exitService } = useExitService();
  const { showDialog } = useDialog();

  const handleClose = () => {
    showDialog({
      title: '비즈넵 환급을 종료하시겠어요?',
      buttons: {
        primary: {
          text: '종료하기',
          onClick: () => {
            exitService();
          }
        },
        secondary: {
          text: '취소'
        }
      }
    });
  };

  return workingPlatform === 'kbank' ? (
    <SignCloseButtonLayout closeAction={handleClose}>
      <CICollectionRequest />
    </SignCloseButtonLayout>
  ) : (
    <SignBackButtonLayout>
      <CICollectionRequest />
    </SignBackButtonLayout>
  );
};

CiPreparePage.getLayout = (page: ReactElement) => <AuthGuard>{page}</AuthGuard>;

export default CiPreparePage;
